import { Link } from 'react-router-dom';
import { AuthLayout } from '@/components/AuthLayout';

export default function Signup() {
  return (
    <AuthLayout>
      <div className="w-full max-w-md">
        <div className="bg-card border border-border rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">Create Account</h1>
            <p className="text-muted-foreground">Join the BlueLux team</p>
          </div>

          {/* Contact Notice Card */}
          <div className="space-y-6">
            {/* Header */}
            <div className="bg-blue-50 dark:bg-blue-950/30 border-2 border-blue-200 dark:border-blue-800 rounded-lg p-6 text-center">
              <div className="mb-3">
                <svg className="w-12 h-12 mx-auto text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-blue-900 dark:text-blue-100 mb-2">
                Access Request Required
              </h2>
              <p className="text-blue-700 dark:text-blue-300 text-sm">
                BlueLux uses a secure vetting process for new team members
              </p>
            </div>

            {/* Contact Information */}
            <div className="bg-card border border-border rounded-lg p-6 space-y-4">
              <p className="text-center text-muted-foreground mb-4">
                Please contact us directly to request access to the team portal
              </p>

              <div className="space-y-3">
                {/* Email Contact */}
                <a 
                  href="mailto:support@bluelux.com"
                  className="flex items-center justify-center gap-3 p-4 bg-primary/5 hover:bg-primary/10 rounded-lg transition-colors group"
                >
                  <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span className="font-medium text-foreground group-hover:text-primary transition-colors">
                    support@bluelux.com
                  </span>
                </a>

                {/* Jobs Page Link */}
                <a 
                  href="https://bluelux.com/jobs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-3 p-4 bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                  <span className="font-medium">
                    View Career Opportunities
                  </span>
                </a>
              </div>

              {/* Helper Text */}
              <div className="mt-6 pt-4 border-t border-border">
                <p className="text-xs text-center text-muted-foreground">
                  Once approved, you'll receive login credentials via email
                </p>
              </div>
            </div>
          </div>

          <div className="mt-6 text-center text-sm text-muted-foreground">
            Already have an account?{' '}
            <Link to="/auth/login" className="text-primary hover:underline font-medium">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
